// Bar chart horizontal — top N (categorias, produtos, clientes).
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, ResponsiveContainer } from "recharts";
import { fmtBRL } from "../../lib/format.ts";
import { chartTheme, SERIES_COLORS, tooltipStyle } from "./theme.ts";

interface Item { name: string; value: number; color?: string }

interface Props {
  data: Item[];
  height?: number;
  formatValue?: (v: number) => string;
  /** Cor única (default: primary do tema) — se quiser colorir cada bar diferente, passa cores em data[i].color */
  fillColor?: string;
}

export function HorizontalBar({ data, height = 320, formatValue = fmtBRL, fillColor }: Props) {
  if (!data.length) return <div className="center-loading">sem dados</div>;
  const t = chartTheme();
  const color = fillColor ?? t.primary;
  const longest = Math.max(...data.map(d => d.name.length));

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={data}
        layout="vertical"
        margin={{ top: 4, right: 16, bottom: 4, left: Math.min(longest * 6, 180) }}
      >
        <CartesianGrid stroke={t.grid} strokeDasharray="3 3" horizontal={false} />
        <XAxis
          type="number"
          tickFormatter={formatValue}
          tick={{ fontSize: 10, fill: t.muted, fontFamily: "JetBrains Mono, monospace" }}
          axisLine={false}
          tickLine={false}
        />
        <YAxis
          dataKey="name"
          type="category"
          tick={{ fontSize: 11, fill: t.text }}
          axisLine={false}
          tickLine={false}
          width={Math.min(longest * 6, 180)}
        />
        <Tooltip
          {...tooltipStyle}
          formatter={(v) => [formatValue(v as number), ""]}
          cursor={{ fill: t.grid, fillOpacity: 0.3 }}
        />
        <Bar dataKey="value" radius={[0, 4, 4, 0]}>
          {data.map((d, i) => (
            <Cell key={i} fill={d.color ?? color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
